/** help.dealhawkpro.io — video tutorial site (repo: help/). */
export const HELP_CENTER_URL = "https://help.dealhawkpro.io";

export function helpCenterUrl(lang: string, id?: string): string {
  return `${HELP_CENTER_URL}${lang === "es" ? "/es" : ""}${id ? `/q/${id}` : ""}` || HELP_CENTER_URL;
}
